import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertiesService } from '../../services/properties.service';
import { UploadImageService } from '../../services/upload-img.service';
import { forkJoin, Subject, switchMap, takeUntil } from 'rxjs';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

declare var bootstrap: any; // para usar el modal de Bootstrap

type PropImage = {
  imageData?: string;
  thumbnail?: string;
  src?: SafeUrl;
  thumbSrc?: SafeUrl;
};

@Component({
  selector: 'app-propertie-details',
  templateUrl: './propertie-details.component.html',
  styleUrls: ['./propertie-details.component.css'],
  standalone: false
})
export class PropertieDetailsComponent implements OnInit, OnDestroy {
  propiedades: any = {};
  tipoOpe: string = '';
  selectedIndex: number = 0;
  private modalInstance: any;
  lastView: string = 'list';
  private destroy$ = new Subject<void>();
  showFullDescription = false;
  // 👇 propiedades del mapa
  center: google.maps.LatLngLiteral = { lat: -33.335, lng: -60.217 }; // fallback
  zoom = 15;
  marker: google.maps.LatLngLiteral | null = null;

  // acá definís la imagen que querés para el marcador
  markerIcon: google.maps.Icon = {
    url: 'assets/icons/mark.png', // o alquiler.png, o el logo de tu inmobiliaria
    scaledSize: new google.maps.Size(40, 40), // tamaño en píxeles
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 40) // punto de anclaje (mitad abajo)
  };

  constructor(
    private activateRoute: ActivatedRoute,
    private propertieService: PropertiesService,
    private uploadImageService: UploadImageService,
    private sanitizer: DomSanitizer
  ) {
    // Cargar filtro desde localStorage
    const filter = localStorage.getItem('filter');
    if (filter) {
      try {
        const parsed = JSON.parse(filter);
        this.tipoOpe = parsed.tipoope?.toLowerCase() ?? '';
      } catch {
        this.tipoOpe = '';
      }
    }
    const saved = localStorage.getItem('viewMode');
    if (saved) this.lastView = saved;
  }
  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

extractTikTokId(url: string): string {
  const match = url.match(/video\/(\d+)/);
  return match ? match[1].split('?')[0] : '';
}
  ngOnInit(): void {
    // ✅ Unificamos en UN SOLO flujo: leemos la ruta y pedimos data + imágenes juntos
    this.activateRoute.paramMap
      .pipe(
        takeUntil(this.destroy$),
        switchMap(params => {
          const id = Number(params.get('id'));
          return forkJoin({
            data: this.propertieService.getpropiedad(id),
            img: this.uploadImageService.getImagenes(id),
          });
        })
      )
      .subscribe(({ data, img }) => {
        // Sanitizamos y prearmamos los src para evitar problemas de seguridad/render
        const imagenes: PropImage[] = (img ?? []).map((x: any) => ({
          ...x,
          src: x?.imageData
            ? this.sanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64,${x.imageData}`)
            : undefined,
          thumbSrc: x?.thumbnail
            ? this.sanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64,${x.thumbnail}`)
            : undefined
        }));

        this.propiedades = { ...data, imagenes };

        // 👇 setear mapa si trae coordenadas
        if (this.propiedades?.domicilio?.lat && this.propiedades?.domicilio?.lng) {
          this.center = {
            lat: this.propiedades.domicilio.lat,
            lng: this.propiedades.domicilio.lng
          };
          this.marker = { ...this.center };
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openModal(index: number) {
    this.selectedIndex = index;
    const modalEl = document.getElementById('carouselModal');
    if (!modalEl) return;

    this.modalInstance = new bootstrap.Modal(modalEl);
    this.modalInstance.show();

    // 👉 Forzamos el recalculo de Swiper cuando el modal es visible
    modalEl.addEventListener(
      'shown.bs.modal',
      () => {
        const mainSwiper = modalEl.querySelector('.main-swiper') as any;
        const thumbsSwiper = modalEl.querySelector('.thumbs-swiper-modal') as any;
        mainSwiper?.swiper?.update();
        thumbsSwiper?.swiper?.update();
        mainSwiper?.swiper?.slideTo(this.selectedIndex, 0);
      },
      { once: true }
    );
  }

  // Llamado en (load) de cada imagen para asegurar update cuando la imagen termina de cargar
  onModalImageLoad() {
    const modalEl = document.getElementById('carouselModal');
    const mainSwiper = modalEl?.querySelector('.main-swiper') as any;
    mainSwiper?.swiper?.update();
  }

  closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }


toggleDescription() {
  this.showFullDescription = !this.showFullDescription;
}
}
